import gql from 'graphql-tag';
import { DEAL_BUILDER_QUOTE_FRAGMENT } from './fragments/dealBuilderQuote.fragment';

export const UPDATE_DEAL_BUILDER_QUOTE = gql`
  mutation UpdateDealBuilderQuote($input: UpdateQuoteInput!, $quoteId: ID!) {
    dealBuilder {
      updateDealBuilderQuote(input: $input, quoteId: $quoteId) {
        entity {
          ...DealBuilderQuoteFields
        }
        success
        error
      }
    }
  }
  ${DEAL_BUILDER_QUOTE_FRAGMENT}
`;
